import { Outlet } from 'react-router-dom'
import MarketingHeader from './MarketingHeader.jsx'
import MarketingFooter from './MarketingFooter.jsx'

/**
 * MarketingLayout
 * Sticky header + main outlet + multi-column footer.
 * Used as the parent route element in src/App.jsx.
 */
export default function MarketingLayout() {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: 'var(--v3-canvas)', color: 'var(--v3-text-primary)' }}
    >
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <MarketingHeader />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  )
}
